import React from 'react'
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import {ErrorBoundary} from 'react-error-boundary'

// pages
import Home from "./pages/home/Home";
import Error from "./pages/Error"
import BookRide from './pages/book_ride/BookRide';
import About from './pages/about/About';

// components
import Fallback from "./components/Fallback";
import Navbar from './components/navbar/Navbar';

function App() {

  const handleError = (error, errorInfo)=>{
    console.log('Logging error : ', error, errorInfo)
  }

  return (
    <Router>
      <ErrorBoundary FallbackComponent={Fallback} onError={handleError}>
        <Navbar/>
        <Routes>
            <Route path='pers_projects/transport_service/' element={<Home/>} />
            <Route path='pers_projects/transport_service/book_ride' element={<BookRide/>}/>
            <Route path='pers_projects/transport_service/about' element={<About/>}/>
            <Route path='pers_projects/transport_service/*' element={<Error/>} />
        </Routes>
      </ErrorBoundary>
    </Router>
  );
}

export default App;
